import React, { Component } from 'react';
import propTypes from "prop-types";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../actions';
import lang from '../constants/Languages.js';
import { withRouter } from 'react-router';
import Cookies from 'universal-cookie';

//import components
import HeaderLogo from '../components/header/HeaderLogo.js';
import HeaderNav from '../components/header/HeaderNav.js';
import HeaderAccess from '../components/header/HeaderAccess.js';
import HeaderContact from '../components/header/HeaderContact.js';
import HeaderSocial from '../components/header/HeaderSocial.js';
import LanguageSwitcher from '../components/header/LanguageSwitcher.js';
import HeaderMobileMenu from '../components/header/HeaderMobileMenu.js';
import Search from './Search.js';

import menuImg from '../assets/icons/menu.svg';
import menuImgContrast from '../assets/icons/menu-contrast.svg';
import searchImg from '../assets/icons/search.svg';
import * as CheckPathname from '../scripts/CheckPathname.js';

const cookies = new Cookies();

const navigatorPolish = () => {
    const language = navigator.language || navigator.languages;

    if (!language) {
        return false;
    }
    
    if (typeof language === 'string') {
        return language.includes('pl');
    } else if (Array.isArray(language)) {
        return language[0].includes('pl');
    } else {
        return false;
    }
}

class Header extends Component {
	constructor() {
		super();
		this.state = {
			isSearchBar: false
		};
	};

	componentDidMount() {
		const { actions, fontSize, contrastColor, clang } = this.props;
		const root = document.getElementsByTagName('html')[ 0 ];
		const body = document.getElementsByTagName('body')[ 0 ];
		const langCookie = cookies.get('lang');
            
        if (!langCookie) {
            const currentLang = navigatorPolish() ? 'pl' : ('en' || clang);
			actions.setLang(currentLang);
			actions.getHeaderMenu(currentLang);
		} else {
			actions.setLang(langCookie);
			actions.getHeaderMenu(langCookie);
		}

		root.setAttribute('class', fontSize);
		body.setAttribute('class', contrastColor);
	};

	componentDidUpdate(prevProps, nextState) {
		const { actions, clang, fontSize, contrastColor, isMenuFixed } = this.props;
		const langCookie = cookies.get('lang');

		if (clang !== prevProps.clang) {
			actions.getHeaderMenu(clang);
			if (langCookie !== clang) {
				cookies.set('lang', clang);
			}
		}

		if (fontSize !== prevProps.fontSize) {
			const root = document.getElementsByTagName('html')[ 0 ];

			root.setAttribute('class', fontSize);
		}

		if (contrastColor !== prevProps.contrastColor) {
			const body = document.getElementsByTagName('body')[ 0 ];

			body.setAttribute('class', contrastColor);
		}

		if (isMenuFixed !== prevProps.isMenuFixed && !isMenuFixed) {
			this.setState({ isSearchBar: false });
		}
	};

	setLang = (lang) => {
		const { actions } = this.props;

		actions.setLang(lang);
	};

	setFontSize = (size) => {
		const { actions, fontSize } = this.props;

		if (size !== fontSize) {
			actions.setFontSize(size);
		}
	};

	setContrast = (contrast) => {
		const { actions, contrastColor } = this.props;

		if (contrast !== contrastColor) {
			actions.setContrast(contrast);
		}
	};

	toggleSearchBar = () => {
		this.setState({ isSearchBar: !this.state.isSearchBar });
	};

	setOpened = (id) => {
		this.setState({ openedElem: id });
	};

	render() {
		const { clang, availableLanguages, menuData, fontSize, contrastColor, toggleMobileMenu, location, isMobile, isMobileMenu, isMenuFixed } = this.props;
		const { isSearchBar, openedElem } = this.state;

		const isAdvancedSearch = CheckPathname.isAdvancedSearch(location);

		return (
			<header className={ `header ${isMenuFixed ? 'fixed' : ''}` }>
				<div className="header-container">
					{ (!isSearchBar || !isMenuFixed) &&
						<div className="header__logo-container">
							<HeaderLogo />
						</div> }

					{ !isMobile &&
						<div className="header__nav-container">
							{ menuData &&
								<HeaderNav data={ menuData } /> }
						</div> }

					{ !isMobile &&
						<div className="header__menu-container">
							<HeaderAccess
								setFontSize={ this.setFontSize }
								setContrast={ this.setContrast }
								setOpened={ this.setOpened }
								openedElem={ openedElem }
								cfont={ fontSize }
								contrast={ contrastColor } />
							<LanguageSwitcher
								type="lang"
								setLang={ this.setLang }
								setOpened={ this.setOpened }
								openedElem={ openedElem }
								availableLanguages={ availableLanguages } />
							<HeaderContact />
							<HeaderSocial />
						</div> }

					{ isMobile && (!(isSearchBar && isMenuFixed) || isAdvancedSearch) &&
						<div className="header__menu-container--mobile">
							<div className="header__mobile-trigger">
								{ isMenuFixed && !isAdvancedSearch &&
									<button className="header__mobile-search__button" title="mobile search button" onClick={ () => this.toggleSearchBar() }>
										<img src={ searchImg } alt="" className="header__mobile-search__img" />
									</button> }
								<button className="header__mobile-trigger__button" onClick={ () => toggleMobileMenu() }>
									<img src={ menuImg } alt="" className="header__mobile-trigger__img" />
									<img src={ menuImgContrast } alt="" className="header__mobile-trigger__img contrast" />
									{ lang[ clang ].main_page.menu }
								</button>
							</div>
							{ menuData && isMobileMenu &&
								<HeaderMobileMenu
									data={ menuData }
									setFontSize={ this.setFontSize }
									cfont={ fontSize }
									setContrast={ this.setContrast }
									contrast={ contrastColor }
									setLang={ this.setLang }
									setOpened={ this.setOpened }
									openedElem={ openedElem }
									availableLanguages={ availableLanguages }
									toggleMobileMenu={ toggleMobileMenu } /> }
						</div> }

					<div className={ `header__menu-container--mobile ${!(isMobile && isSearchBar && isMenuFixed) || isAdvancedSearch ? 'hidden' : ''}` }>
						<Search isOnlyForm={ true } />
						<div role='button' className="header__mobile-search__close-button" onClick={ () => this.toggleSearchBar() }></div>
					</div>
				</div>
			</header>
		);
	};
};

Header.propTypes = {
	clang: propTypes.string.isRequired,
	availableLanguages: propTypes.arrayOf(
		propTypes.string
	).isRequired,
	menuData: propTypes.arrayOf(
		propTypes.object
	),
	actions: propTypes.object.isRequired,
	fontSize: propTypes.string.isRequired,
	contrastColor: propTypes.string.isRequired,
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage,
	availableLanguages: state.language.availableLanguages,
	menuData: state.mainPage.menuData,
	fontSize: state.font.size,
	contrastColor: state.contrast.contrast,
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(Actions, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./src/containers/Header.js